import { Fragment, type ReactNode } from "react";

export const PHONE_DISPLAY = "717-725-7170";
export const PHONE_HREF = "tel:+17177257170";

const PHONE_PATTERN = /717-725-7170/g;

/**
 * Wrap every occurrence of the business phone number inside a string with a
 * best-practice `tel:` link (E.164 format), returning React nodes. Non-string
 * values and strings without the number are returned unchanged, so this is safe
 * to apply liberally at prose render points.
 */
export function linkifyPhone(
  value: ReactNode,
  className = "text-primary font-medium underline underline-offset-2 hover:opacity-80",
): ReactNode {
  if (typeof value !== "string" || !value.includes(PHONE_DISPLAY)) {
    return value;
  }
  const segments = value.split(PHONE_PATTERN);
  return segments.map((segment, index) => (
    <Fragment key={index}>
      {segment}
      {index < segments.length - 1 && (
        <a href={PHONE_HREF} className={className}>
          {PHONE_DISPLAY}
        </a>
      )}
    </Fragment>
  ));
}
